module.exports = __webpack_public_path__ + "static/img/fura.a8d702a.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fura.gif
// module id = Q0K/
// module chunks = 0